
import { call, put, takeEvery } from "redux-saga/effects"

import {
    GET_ADMIN_TICKETS,
    GET_ADMIN_TICKET_DETAIL,
    UPDATE_TICKET_STATUS,
    REPLY_TICKET,
} from "./actionTypes"

import {
    getAdminTicketsSuccess,
    getAdminTicketsFail,
    getAdminTicketDetailSuccess,
    getAdminTicketDetailFail,
    updateTicketStatusSuccess,
    updateTicketStatusFail,
    replyTicketSuccess,
    replyTicketFail,
} from "./actions"

import {
    getAdminTickets,
    getAdminTicketDetail,
    updateTicketStatus,
    replyTicket,
} from "../../helpers/fakebackend_helper"

function* fetchTickets({ payload: params }) {
    try {
        const response = yield call(getAdminTickets, params)
        yield put(getAdminTicketsSuccess(response))
    } catch (error) {
        yield put(getAdminTicketsFail(error))
    }
}

function* fetchTicketDetail({ payload: id }) {
    try {
        const response = yield call(getAdminTicketDetail, id)
        yield put(getAdminTicketDetailSuccess(response))
    } catch (error) {
        yield put(getAdminTicketDetailFail(error))
    }
}

function* onUpdateTicketStatus({ payload: { id, data } }) {
    try {
        const response = yield call(updateTicketStatus, id, data)
        yield put(updateTicketStatusSuccess(response.ticket))
    } catch (error) {
        yield put(updateTicketStatusFail(error))
    }
}

function* onReplyTicket({ payload: { id, data } }) {
    try {
        const response = yield call(replyTicket, id, data)
        yield put(replyTicketSuccess(response.reply))
    } catch (error) {
        yield put(replyTicketFail(error))
    }
}

function* ticketsAdminSaga() {
    yield takeEvery(GET_ADMIN_TICKETS, fetchTickets)
    yield takeEvery(GET_ADMIN_TICKET_DETAIL, fetchTicketDetail)
    yield takeEvery(UPDATE_TICKET_STATUS, onUpdateTicketStatus)
    yield takeEvery(REPLY_TICKET, onReplyTicket)
}

export default ticketsAdminSaga
